import { render, staticRenderFns } from "./insurer-plan.vue?vue&type=template&id=5390a001&scoped=true&"
import script from "./insurer-plan.vue?vue&type=script&lang=js&"
export * from "./insurer-plan.vue?vue&type=script&lang=js&"
import style0 from "./insurer-plan.vue?vue&type=style&index=0&id=5390a001&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5390a001",
  null
  
)

export default component.exports